import { InsuranceDocumentResponse, InsurancePassengerResponse, InsuranceResponse } from "../api/InsuranceResponse";

export class Insurance {
	insuranceType: string;
	totalPrice: number;
	passengers: InsurancePassenger[];
	documents: InsuranceDocument[];

	constructor(resp: InsuranceResponse, documents: InsuranceDocumentResponse[] = []) {
		this.insuranceType = resp.insuranceType;
		this.passengers = resp.passengers.map(p => new InsurancePassenger(p))
		if (documents) {
			this.documents = documents.map(d => new InsuranceDocument(d));
		} else {
			this.documents = [];
		}
		this.totalPrice = resp.totalPrice;
	}
}

export class InsurancePassenger {
	id: string;
	insuranceType: string;
	identifier: string;
	name: string;
	nameListId: string;

	constructor(resp: InsurancePassengerResponse) {
		this.id = `${resp.insuranceType}|${resp.nameListId}`;
		this.insuranceType = resp.insuranceType;
		this.identifier = resp.identifier;
		this.name = resp.name;
		this.nameListId = resp.nameListId;
	}
}

export class InsuranceDocument {
	name: string;
	url: string;

	constructor(resp: InsuranceDocumentResponse) {
		this.name = resp.name;
		this.url = resp.url;
	}
}